module.exports = __webpack_public_path__ + "img/20200620_094100.5ffccc62.jpg";